export default __webpack_public_path__ + "static/media/jrvclassics_tile_mid.fa22dfa9.jpg";